// Lo que el mock muestra y el back todavía no soporta: se pinta deshabilitado con este motivo.
export { MISSING_PRODUCT_TYPE, MISSING_PRODUCT_TYPES } from '@/shared/domain/productScope';

export const MISSING_CHANNEL =
    'Falta en el sistema: las promos todavía no se pueden limitar por canal de venta.';

export const MISSING_EDIT_DIFF =
    'Falta en el sistema: el historial todavía no guarda qué cambió en cada edición.';
